/**
 * DatabaseType constant. Used to know which database the app is using
 */
 export const DatabaseType = {
  mySQL: 'mySQL',
  mongoDB: 'mongoDB'
}